import React, {Component} from 'react';
import {login, request} from "./helper/APIUtils";
import {ACCESS_TOKEN, KEEP_SESSION_OPEN, SERVLET_PATH} from "./constants";
import {Button, Col, Input, Label, Row} from "reactstrap";
import ForgotPassword from "./components/ForgotPassword";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import {isVakifbank} from "./helper/permission";

class Login extends Component {

	constructor(props) {
		super(props);
		this.state = {
			error: {},
			errorMessage: '',
			errorType: "",
			username: '',
			password: '',
			processing: false,
			passwordHandle: false,
			keepSessionOpen: false,
			enableForgotSection: false,
			verificationCode: "",
			otpModal: false,
			access_token: null,
			isPlaying: true,
			referenceCode: null
		};
		this.handleSubmit = this.handleSubmit.bind(this);
		this.onChange = this.onChange.bind(this);
		this.handleKeyPress = this.handleKeyPress.bind(this);
		this.handleKeyPressForVerification = this.handleKeyPressForVerification.bind(this);
		this.validateForm = this.validateForm.bind(this);
		this.onChangeCheck = this.onChangeCheck.bind(this);
		this.openCloseForgotPassword = this.openCloseForgotPassword.bind(this);
		this.sendNew = this.sendNew.bind(this);
		this.verifyTwoStep = this.verifyTwoStep.bind(this);
		this.onExpire = this.onExpire.bind(this);
	}

	componentDidMount() {

		if (this.props.match &&
			this.props.match.params &&
			this.props.match.params.base64login) {
			let base64 = this.props.match.params.base64login;
			let decode64;
			try {
				if (!!base64) {
					decode64 = atob(base64);
					if (btoa(decode64) === base64) {
						if (!!decode64 && decode64.includes(":")) {
							if(!!decode64.split(":")[0] && decode64.split(":")[0] !== ' ' && decode64.split(":")[0].trim() !== '' && !!decode64.split(":").slice(1).join(":")){
								let username = decode64.split(":")[0];
								let password = decode64.split(":").slice(1).join(":");
								this.setState({username, password, keepSessionOpen: true}, () => this.handleSubmit());
							}
						}
					}
				}
			} catch (e) {
			}
		}

		if (this.props.match &&
			this.props.match.params &&
			this.props.match.params.username &&
			this.props.match.params.password) {
			let {username, password} = this.props.match.params;
			this.setState({username, password, keepSessionOpen: true});
		}
	}

	onChangeCheck() {
		let keepSessionOpen = this.state.keepSessionOpen;
		this.setState({keepSessionOpen: !keepSessionOpen});
	}

	onChange(e) {
		this.setState({[e.target.id]: e.target.value, errorMessage: "", errorType: ""})
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	validateForm() {
		if (!!this.state.username && !!this.state.password) {
			return true;
		} else {
			let userMsg = "";
			let passMsg = "";
			if (!this.state.username) {
				userMsg = "Kullanıcı adı "
			}
			if (!this.state.password) {
				passMsg = "Şifre "
			}
			if (userMsg && passMsg)
				this.setState({errorMessage: userMsg + " ve " + passMsg + " girmediniz", errorType: "warning"})
			else
				this.setState({errorMessage: userMsg + passMsg + " girmediniz", errorType: "warning"})

			return false;
		}
	}

	handleKeyPress(event) {
		if (event.key === 'Enter') {
			this.handleSubmit();
		}
	}

	handleKeyPressForVerification(event) {
		if (event.key === 'Enter') {
			this.verifyTwoStep();
		}
	}

	handleSubmit() {
		let self = this;

		if (!this.validateForm()) return;

		const loginRequest =
			{
				'username': this.state.username,
				'password': this.state.password
			};

		self.setState({processing: true})
		login(loginRequest)
			.then(response => {
				if (response.data.hasOtp) {
					self.setState({
						processing: false,
						errorType: "",
						otpModal: true,
						isPlaying: true,
						userId: response.data.userId,
						referenceCode: response.data.referenceCode
					});
				} else if(response.data.requirePasswordReset) {
					const message = "Şifrenizin geçerlilik süresi dolduğu için yeni bir şifre belirlemelisiniz.";
					this.props.history.push({
						pathname: `/reset-password`,
						state: { requirePasswordReset: true, message: message }
					});
				}
				else {
					const parentCustomerId = response.data.parentCustomerId;
					if (parentCustomerId) {
						localStorage.setItem("parentCustomerId", parentCustomerId);
					}
					localStorage.setItem(ACCESS_TOKEN, response.data.token.accessToken);
					localStorage.setItem(KEEP_SESSION_OPEN, self.state.keepSessionOpen.toString());
					self.setState({processing: false, errorType: ""}, () => self.props.onLogin());
				}
			}).catch(error => {
			let errorMessage = "";
			errorMessage = error.response.data ? error.response.data : 'Bir sorun oluştu.';
			self.setState({errorMessage, processing: false, errorType: "danger"})
		});

	}

	openCloseForgotPassword(value) {
		let self = this;
		self.setState({enableForgotSection: value})
	}

	sendNew() {
		let self = this;
		let params = {
			url: "auth/sendVerificationCodeAgain",
			method: "post",
			data: {
				userId: self.state.userId,
			}
		}
		request(params)
			.then(response => {
				self.setState({
					processing: false,
					errorType: "",
					referenceCode: response.data.referenceCode,
					isPlaying: true,
					errorMessage: false,
				});
			})
			.catch(error => {
				let response = error.response;
				let status = response.status;
				let errorMessage = "";
				if (!!status && status >= 400 && status !== 500) {
					errorMessage = response.data;
				} else {
					errorMessage = error.message ? error.message : 'Bir sorun oluştu.';
				}
				self.setState({errorMessage, processing: false, errorType: "danger"})
			});
	}

	verifyTwoStep() {
		let self = this;
		const loginRequest =
			{
				'username': this.state.username,
				'password': this.state.password
			};
		let params = {
			url: "/auth/verifyTwoStepCode",
			method: "post",
			data: {
				verificationCode: self.state.verificationCode,
				loginRequest: loginRequest
			}
		};
		request(params)
			.then(response => {
				localStorage.setItem(ACCESS_TOKEN, response.data.token.accessToken);
				localStorage.setItem(KEEP_SESSION_OPEN, self.state.keepSessionOpen.toString());
				self.setState({processing: false, errorType: ""}, () => self.props.onLogin());
			})
			.catch(error => {
				let errorMessage = "";
				errorMessage = error.response.data ? error.response.data : 'Bir sorun oluştu.';
				self.setState({errorMessage, processing: false, errorType: "danger"})
			});
	}

	onExpire(){
		let self = this;
		let params = {
			url: "/auth/deleteExpired",
			method: "post",
			data: {
				referenceCode: self.state.referenceCode,
				userId: self.state.userId,
			}
		};
		request(params)
			.then(response => {
				this.setState({
					errorMessage: "Süreniz doldu. Lütfen yeni şifre alın.",
					isPlaying: false
				});
			})
			.catch(error => {
				let errorMessage = "";
				errorMessage = error.message ? error.message : 'Bir sorun oluştu.';
				self.setState({errorMessage, processing: false, errorType: "danger"})
			});
	}

	decideLoginImageStyle = () => {
		return isVakifbank() ? {textAlign: 'center', padding: '45px 3% 3% 3%'} : {textAlign: 'center', padding: '0 3% 3% 3%'};
	}

	render() {
		const renderTime = ({remainingTime}) => {
			return (
				<div className="timer">
					<div style={{fontSize: 20, fontWeight: "bold"}}>{remainingTime}</div>
				</div>
			);
		}

		return (
			<Row style={{
				height: '100vh',
				backgroundImage: 'url(' + SERVLET_PATH + "/api/virtual/resource/loginBackground.png" + ')'
			}}>
				<Col sm='12' md='12' lg='12' className='login-panel-container'>
					{!this.state.otpModal &&
					<Row className='login-panel' >
						<Col xs='12' sm='12' md='4' lg='4' style={this.decideLoginImageStyle()}>
							<img src={SERVLET_PATH + "/api/virtual/resource/login.png"} alt="now-logo"/>
						</Col>
						{this.state.enableForgotSection &&
						<ForgotPassword close={this.openCloseForgotPassword}/>
						}


						{!this.state.enableForgotSection &&
						<Col xs='12' sm='12' md='8' lg='8' style={{padding: '2% 2% 3% 2%'}}>
							<Col sm='12' md='12' lg='12' className="no-border  input-group input-group-lg">
								<span className="input-group-addon">
									<i style={{fontSize: '15px', color: '#e8e8e8'}}
									   className="now-ui-icons users_circle-08"/>
								</span>

								<input placeholder="Kullanıcı Adı"
									   autoComplete="true"
									   autoFocus
									   id="username"
									   name="username"
									   style={{
										   borderLeft: '1px solid #c3cdd4',
										   background: 'rgba(130,129,129,0.6)',
										   color: 'white',
										   fontSize: '14px',
										   fontWeight: 'bold'
									   }}
									   onKeyPress={this.handleKeyPress}
									   onChange={this.onChange}
									   value={this.state.username}
									   className="loginText form-control"
									   type="text"/>
							</Col>


							<Col sm='12' md='12' lg='12' className="no-border  input-group input-group-lg">
								<span className="input-group-addon">
									<i style={{fontSize: '15px', color: '#e8e8e8'}} className="fa fa-asterisk"
									   aria-hidden="true"/>
								</span>

								<input placeholder="Şifre"
									   autoComplete="true"
									   id="password"
									   name="password"
									   style={{
										   borderLeft: '1px solid #c3cdd4',
										   background: 'rgba(130,129,129,0.6)',
										   color: 'white',
										   fontSize: '14px',
										   fontWeight: 'bold'
									   }}
									   onKeyPress={this.handleKeyPress}
									   onChange={this.onChange}
									   value={this.state.password}
									   className="loginText form-control"
									   type="password"/>
							</Col>

							<Col sm="12" md="12" lg="12" className="no-border input-group input-group-lg d-flex justify-content-between">
								<Label style={{
									paddingLeft: "2.5rem",
									fontSize: "14px",
									fontWeight: "bold",
									color: "#58595e"
								}} check>
									<Input type="checkbox"
										   id="checkbox"
										   style={{ paddingLeft: "1rem", fontSize: "12px", fontWeight: "bold" }}
										   checked={this.state.keepSessionOpen}
										   onChange={(e) => this.onChangeCheck(e)} />{' '}
									Oturum Açık Kalsın
								</Label>
								<Label className="forgot-password">
									<a onClick={() => this.openCloseForgotPassword(true)}>Şifremi Unuttum</a>
								</Label>
							</Col>

							{this.state.errorMessage &&
							<Col sm='12' md='12' lg='12'
								 style={{textAlign: 'center', padding: '0', margin: '4% 0 0 0'}}>
								<label className='errorMessage'>{this.state.errorMessage}</label>
							</Col>}

						</Col>
						}
						{!this.state.enableForgotSection &&
						<Col xs='12' sm='12' md='12' lg='12' className='login-button-container'>
							<Button color="blue" className={isVakifbank() ? 'login-button-vakifbank' : 'login-button'}
									style={isVakifbank() ? {fontWeight: 'bold', color: 'black'} : {}}
									onClick={this.handleSubmit}>
								{!this.state.processing ? 'GİRİŞ' : <i className="fa fa-spinner fa-spin"/>}
							</Button>
						</Col>
						}
					</Row>
					}

					{this.state.otpModal &&
					<Row className='login-panel'>
						<Col xs='12' sm='12' md='4' lg='4' style={{textAlign: 'center', padding: '0 3% 3% 3%'}}>
							<img src={SERVLET_PATH + "/api/virtual/resource/login.png"} alt="now-logo"/>
						</Col>

						<Col xs='12' sm='12' md='8' lg='8' style={{padding: '2% 2% 3% 2%'}}>
							<Col sm='12' md='12' lg='12' className="no-border  input-group input-group-lg">

								<span className="input-group-addon" style={{width: "25%"}}>
									<label>Doğrulama Kodu</label>
									{/*<i style={{fontSize: '15px', color: '#d0dbe0'}} className="fa fa-check-square"*/}
									{/*   aria-hidden="true"/>*/}
								</span>

								<input placeholder="Doğrulama Kodu"
									   id="verificationCode"
									   name="verificationCode"
									   maxLength={6}
									   style={{
										   borderLeft: '1px solid #c3cdd4',
										   background: 'rgba(42,42,43,0.6)',
										   color: 'white',
										   fontSize: '14px',
										   fontWeight: 'bold'
									   }}
									   onChange={this.onChange}
									   value={this.state.verificationCode}
									   className="loginText form-control"
									   type="text"/>
							</Col>

							<Col sm='12' md='12' lg='12' className="no-border  input-group input-group-lg">

								<span className="input-group-addon" style={{width: "25%"}}>
									<label>Referans Kodu</label>
									{/*<i style={{fontSize: '15px', color: '#d0dbe0'}} className="fa fa-check-square"*/}
									{/*   aria-hidden="true"/>*/}
								</span>

								<input placeholder="Referans Kodu"
									   id="referenceCode"
									   name="referenceCode"
									   style={{
										   borderLeft: '1px solid #c3cdd4',
										   background: 'rgba(42,42,43,0.6)',
										   color: 'white',
										   fontSize: '14px',
										   fontWeight: 'bold'
									   }}
									   disabled={true}
									   value={this.state.referenceCode}
									   className="loginText form-control"
									   type="text"/>
							</Col>

							{this.state.errorMessage &&
							<Col sm='12' md='12' lg='12'
								 style={{textAlign: 'center', padding: '0', margin: '4% 0 0 0'}}>
								<label className='errorMessage'>{this.state.errorMessage}</label>
							</Col>}

							<Col sm='12' md='12' lg='12'
								 style={{textAlign: 'center', padding: '0', margin: '4% 0 0 0'}}>

								{this.state.isPlaying &&
								<div className="timer-wrapper">

									<label className={"timer-label"} style={{fontWeight: "bold", color: "rgba(68,66,66,0.75)"}}>Kalan süreniz:</label>

									<CountdownCircleTimer
										isPlaying={this.state.isPlaying}
										duration={180}
										isLinearGradient={true}
										colors={[["#2c6397", 0], ["#338934"]]}
										onComplete={() => this.onExpire()}
										size={70}
										strokeWidth={4}
										trailColor="#9A9A9AFF"
									>
										{renderTime}
									</CountdownCircleTimer>

									<Label className={"timer-label"} style={{fontWeight: "bold",color: "rgba(68,66,66,0.75)"}}>saniyedir.</Label>
								</div>
								}
								<button
									className="btn btn-primary"
									onClick={this.sendNew}
									disabled={this.state.isPlaying}
								>Yeni Şifre al
								</button>
								<Button color="blue" className='login-button'
										onClick={this.verifyTwoStep}
										disabled={!this.state.isPlaying}>
									{!this.state.processing ? 'DOĞRULA' : <i className="fa fa-spinner fa-spin"/>}
								</Button>
							</Col>

						</Col>
					</Row>
					}
				</Col>
			</Row>
		);
	}
}

export default Login;